import React from "react";
import { string, number, object } from "prop-types";

import FB from "../../icons/fb";
import Twitter from "../../icons/twitter";
import Instagram from "../../icons/instagram";
import Pinterest from "../../icons/pinterest";
import Youtube from "../../icons/youtube";

import "./socialIcons.m.css";

const SocialIcons = ({ color = "#000", width = 24, height = 24, socialLinks = {} }) => {
  const list = [];

  list.push({
    type: "fb",
    url: socialLinks["facebook-url"] || "",
    icon: <FB />
  });

  list.push({
    type: "twitter",
    url: socialLinks["twitter-url"] || "",
    icon: <Twitter />
  });

  list.push({
    type: "instagram",
    url: socialLinks["instagram-url"] || "",
    icon: <Instagram />
  });

  list.push({
    type: "youtube",
    url: socialLinks["youtube-url"] || "",
    icon: <Youtube />
  });

  return (
    <ul className="icon-list social-media-icon-wrapper">
      {list.map((item, index) => {
        return (
          <li styleName="icon-item" className={item.type} key={index}>
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              {item.icon}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

SocialIcons.propTypes = {
  color: string,
  width: number,
  height: number,
  socialLinks: object,
  config: object
};

export default SocialIcons;
